import { api } from "@/lib/api";

const WASM = "https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@1.2.0/wasm";
const MODEL = "https://storage.googleapis.com/mediapipe-models/face_detector/blaze_face_short_range/float16/1/blaze_face_short_range.tflite";
let detP = null;

const detector = () => {
  if (!detP) {
    detP = import("@mediapipe/tasks-vision").then(async ({ FaceDetector, FilesetResolver }) => {
      const vision = await FilesetResolver.forVisionTasks(WASM);
      return FaceDetector.createFromOptions(vision, { baseOptions: { modelAssetPath: MODEL }, runningMode: "IMAGE", minDetectionConfidence: 0.5 });
    }).catch(() => { detP = null; return null; });
  }
  return detP;
};

export const getGeo = () => new Promise((res, rej) => {
  if (!navigator.geolocation) { rej(new Error("GPS tidak tersedia di perangkat ini")); return; }
  navigator.geolocation.getCurrentPosition((p) => res({ lat: p.coords.latitude, lng: p.coords.longitude, accuracy: p.coords.accuracy }),
    () => rej(new Error("GPS wajib aktif — izinkan akses lokasi di HP / browser")), { enableHighAccuracy: true, timeout: 15000, maximumAge: 0 });
});

export const reverseGeo = async (lat, lng) => {
  try {
    const r = await fetch(`https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}&zoom=17&accept-language=id`);
    return ((await r.json()).display_name || "").split(",").slice(0, 4).join(",");
  } catch { return ""; }
};

export const searchPlace = async (q) => {
  try {
    const r = await fetch(`https://nominatim.openstreetmap.org/search?format=json&limit=5&countrycodes=id&q=${encodeURIComponent(q)}`);
    return (await r.json()).map((x) => ({ lat: +x.lat, lng: +x.lon, label: x.display_name }));
  } catch { return []; }
};

export const parseCoords = (s) => {
  const m = String(s || "").match(/(-?\d{1,2}\.\d+)\s*,\s*(-?\d{1,3}\.\d+)/) || String(s || "").match(/@(-?\d{1,2}\.\d+),(-?\d{1,3}\.\d+)/);
  return m ? { lat: +m[1], lng: +m[2] } : null;
};

const loadImg = (file) => new Promise((res, rej) => { const i = new Image(); i.onload = () => res(i); i.onerror = rej; i.src = URL.createObjectURL(file); });

// Foto diberi keterangan jam + GPS + alamat, dicek jumlah wajah (opsional), lalu di-upload
export const stampAndUpload = async (file, { geo, title = "", face = false, uploadUrl = "/attendance/upload" }) => {
  const img = await loadImg(file);
  const sc = Math.min(1, 1280 / Math.max(img.width, img.height));
  const c = document.createElement("canvas"); c.width = Math.round(img.width * sc); c.height = Math.round(img.height * sc);
  const g = c.getContext("2d"); g.drawImage(img, 0, 0, c.width, c.height);
  let faces = null;
  if (face) { const det = await detector(); if (det) { try { faces = det.detect(c).detections.length; } catch { faces = null; } } }
  const address = await reverseGeo(geo.lat, geo.lng);
  const when = new Date().toLocaleString("id-ID", { timeZone: "Asia/Jakarta", dateStyle: "medium", timeStyle: "medium" });
  const lines = [title, `${when} WIB`, `GPS ${geo.lat.toFixed(6)}, ${geo.lng.toFixed(6)} (±${Math.round(geo.accuracy || 0)} m)`, address].filter(Boolean);
  const fs = Math.max(14, Math.round(c.width / 42)); const pad = fs * 0.6;
  g.fillStyle = "rgba(0,0,0,0.55)"; g.fillRect(0, c.height - lines.length * fs * 1.35 - pad * 2, c.width, lines.length * fs * 1.35 + pad * 2);
  g.fillStyle = "#fff"; g.font = `600 ${fs}px sans-serif`;
  lines.forEach((t, i) => g.fillText(t.slice(0, 90), pad, c.height - pad - (lines.length - 1 - i) * fs * 1.35));
  const blob = await new Promise((r) => c.toBlob(r, "image/jpeg", 0.85));
  const fd = new FormData(); fd.append("file", blob, "absen.jpg");
  const { data } = await api.post(uploadUrl, fd, { headers: { "Content-Type": "multipart/form-data" } });
  return { path: data.path, faces, address, preview: c.toDataURL("image/jpeg", 0.5) };
};
